export default "/_next/static/images/modal-bottom-edge-texture-793586f532d5586b2f3a90df3016a260.svg";